import { SVG_invoice } from "../elements/SVG";
import { getText } from '@educaplay/app-core/language';

export const TeamPlanContact = ({ planId, numPlans, handleOpenTeamPlan }) => (
    <div className="e__plns__lst__plan__form radius-lg px-lg py-lg">
      <div className="width-full font-bold">
        {getText("team_plan_title")}
      </div>
      <div className="width-full py-md">
        {getText("team_plan_description")}
      </div>
      <button
        className="e-btn e-btn--lg e-btn--premium"
        onClick={() => handleOpenTeamPlan(planId, numPlans)}
        type="button"
      >
        <span>
          <SVG_invoice />
        </span>
        <span className="e__btn__txt">
          {getText("contactar_ventas")}
        </span>
      </button>
    </div>
);